import BookingCalendly from './BookingCalendly';
import Calendly from './Calendly';

export { Calendly, BookingCalendly };

export const getCalendlyUrl = (
    notEmployed: boolean,
    applyBackgroundColor: boolean = false,
) => {
    const env = window?._env_?.ENV?.toUpperCase();

    let queryParams = '?hideCookieBanner=1';

    if (applyBackgroundColor) {
        queryParams += '&background_color=FBFAF9';
    }

    const prodURL = 'https://calendly.com/selinaadvance/';
    const testUrl = 'https://calendly.com/gearoid-houston-selinafinance/';

    if (env === 'PRODUCTION') {
        return notEmployed
            ? `${prodURL}call-with-our-team-decision-in-pre-qual${queryParams}`
            : `${prodURL}advice${queryParams}`;
    } else {
        return notEmployed
            ? `${testUrl}30-minute-meeting-with-sales-qualifier${queryParams}`
            : `${testUrl}30min${queryParams}`;
    }
};
